import { render } from "./Transcripts.vue?vue&type=template&id=198cb71c&scoped=true"
import script from "./Transcripts.vue?vue&type=script&lang=js"
export * from "./Transcripts.vue?vue&type=script&lang=js"

import "./Transcripts.vue?vue&type=style&index=0&id=198cb71c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198cb71c"]])

export default __exports__